import moment from 'moment';

export function convertEndTime(timeRange: string, locale?: string) {
  const end = timeRange.split(' - ')[1];
  const endHour = parseInt(end.split(':')[0], 10);
  const endFormatted = endHour > 12 ? `${endHour - 12} pm` : `${endHour} am`;
  return `${locale === 'en' ? 'Open until' : "Ouvert jusqu'à"} ${endFormatted}`;
}

export function isBetweenTimes(time: string) {
  if (!time) return false;
  const timeNow = moment();
  const startTime = moment(time?.split(' - ')[0], 'h:mma');
  const endTime = moment(time?.split(' - ')[1], 'h:mma');
  return timeNow.isBetween(startTime, endTime);
}
